import React, {PropsWithChildren} from 'react'

import * as t from '../types'
import {useMapComponent} from './hooks'

export {MapClusterer} from './MapClusterer'
export {
  getGeolocationFromBrowser,
  getGeolocationPermission,
  MapGeolocationCustomControl,
} from './MapGeolocationCustomControl'
export {MapZoomCustomControl} from './MapZoomCustomControl'

export const MapControl: React.FC<PropsWithChildren<t.MapControlProps>> = props => {
  const MapComponent = useMapComponent<PropsWithChildren<t.MapControlProps>>('YMapControl')
  return MapComponent && <MapComponent {...props} />
}
export const MapControls: React.FC<PropsWithChildren<t.MapControlsProps>> = props => {
  const MapComponent = useMapComponent<t.MapControlsProps>('YMapControls')
  return MapComponent && <MapComponent {...props} />
}
export const MapFeature: React.FC<PropsWithChildren<t.MapFeatureProps>> = props => {
  const MapComponent = useMapComponent<t.MapFeatureProps>('YMapFeature')
  return MapComponent && <MapComponent {...props} />
}
export const MapGeolocationControl: React.FC<t.MapGeolocationControlProps> = props => {
  const MapComponent = useMapComponent<t.MapGeolocationControlProps>('YMapGeolocationControl')
  return MapComponent && <MapComponent {...props} />
}
export const MapListener: React.FC<PropsWithChildren<t.MapListenerProps>> = props => {
  const MapComponent = useMapComponent<t.MapListenerProps>('YMapListener')
  return MapComponent && <MapComponent {...props} />
}
export const MapZoomControl: React.FC<t.MapZoomControlProps> = props => {
  const MapComponent = useMapComponent<t.MapZoomControlProps>('YMapZoomControl')
  return MapComponent && <MapComponent {...props} />
}
